import Factory from "../Factory";
import { FactoryInterface } from "../FactoryInterface";

import CompanyFactory from "./CompanyFactory";
import AttachmentFactory from "./AttachmentFactory";

import { Property } from "../Entities/Property/Property";
import { PropertyInterface } from "../Entities/Property/PropertyInterface";
import { AttachmentInterface } from "../Entities/Attachment/AttachmentInterface";

class PropertyFactory extends Factory implements FactoryInterface {

  public create(data: any): PropertyInterface {
    const attachments: AttachmentInterface[] = AttachmentFactory.createFromArray(data.attachments);
    return new Property({
      id: data.id || 0,
      displayName: data.displayName || "",
      contactId: data.contactId || 0,
      companyId: data.companyId || 0,
      unitIds: this.getUnits(data.units),
      company: data.company ? CompanyFactory.create(data.company) : null,
      attachments: attachments,
      avatar: this.getAvatar(attachments, "property"),
      address: this.generateAddress(data.address),
      updatedAt: new Date(data.updatedAt),
      removed: data.removed,
      note: data.note,
      managerId: data.managerId,
      agencyBankAccount: data.agencyBankAccount,
      contactInformationOfAssociation: data.contactInformationOfAssociation,
      associationOwnerId: data.associationOwnerId || 0,
      complexName: data.complexName || ""
    });
  }

  public reinitialize(data: any): PropertyInterface {
    return new Property({
      ...data,
      avatar: this.getAvatar(data.attachments, "property"),
    });
  }
}

export default new PropertyFactory();
